import { useCallback } from 'react';
import SelectAsync, { } from 'react-select/async';
import type { CustomFilter } from '@trinity/chat';
import { CustomFilterMultiselect } from './CustomFilter.Multiselect';
import type { AgentFilterItem, FilterData } from './interfaces';
import { FilterTypeEnum } from './interfaces';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';

type Props = {
  agentIdentifier: string;
  filter: AgentFilterItem;
  values: CustomFilter.ItemValue[];
  onValuesChange: (values: CustomFilter.ItemValue[]) => void;
};

export const AgentCustomFilterValueSelector = ({ agentIdentifier, filter, values, onValuesChange }: Props) => {
  if (filter.type === FilterTypeEnum.Autocomplete) {
    return (
      <AutoCompleteFilterValueSelector
        agentIdentifier={agentIdentifier}
        filter={filter}
        values={values}
        onValuesChange={onValuesChange}
      />
    );
  } else if (filter.type === FilterTypeEnum.Dropdown || filter.type === FilterTypeEnum.DateRange) {
    const filterData = filter.data as FilterData<FilterTypeEnum.Dropdown | FilterTypeEnum.DateRange>;
    const availableValues = filterData.items.map(item => ({
      id: item.key,
      name: item.value,
    }));
    return (
      <CustomFilterMultiselect
        placeholder="Select values..."
        options={availableValues}
        value={values}
        onSelect={onValuesChange}
      />
    );
  }

  return null;
};


const AutoCompleteFilterValueSelector = (props: Props) => {

  const apiClient = useChatApiClient();

  const loadOptions = useCallback(((inputValue: string) => {
    return apiClient.agentResources.searchAgentFilter({ agentIdentifier: props.agentIdentifier, filterId: props.filter.id, query: inputValue })
      .then(response => response.results.map<CustomFilter.ItemValue>(item => ({
        id: item.id.toString(),
        name: item.name,
      })));
  }), [props.agentIdentifier, props.filter.id]);

  return (
    <SelectAsync
      loadOptions={loadOptions}
      value={props.values}
      getOptionLabel={option => option.name}
      getOptionValue={option => option.id}
      onChange={props.onValuesChange}
      isMulti
      placeholder="Type to search..." />
  );
};